import { Badge } from '@chakra-ui/react';

const InvoiceStatus = ({ status }) => {
  const invoiceStatusConfig = {
    paid: {
      label: 'Paid',
      color: 'success',
    },
    draft: {
      label: 'Due',
      color: 'lightgray',
      backgroundColor: '#808080',
    },
    open: {
      label: 'Overdue',
      color: 'error',
      backgroundColor: '#FF0000',
    },
    trial: {
      label: 'Trial',
      color: 'warning',
      backgroundColor: '#FFA500',
    },
    void: {
      label: 'Void',
      color: 'lightgray',
      backgroundColor: '#808080',
    },
    uncollectible: {
      label: 'Uncollectible',
      color: 'error',
      backgroundColor: '#FF0000',
    },
  };

  const statusConfig = invoiceStatusConfig[status] || {
    label: 'Unknown',
    color: 'lightgray',
  };

  return (
    <Badge backgroundColor={statusConfig.color}>{statusConfig.label}</Badge>
  );
};

export default InvoiceStatus;
